<template>
    <div class="filter-item filter-item--checkbox">
        <h2 class="filter-item__heading" v-text="title"></h2>
        <checkbox :name="checkboxName" :value="value" @checked="(val) => value = val"></checkbox>
    </div>
</template>

<script>
import Checkbox from '../checkbox.vue'
import { trackEvent } from '../../tracker';

export default {
    props: {
        title: {type: String, default: ''},
        checkboxName: {type: String, default: null},
        icon: {type: String, default: ''},
        filterValue: {type: String, default: ''}
    },
    data() {
        return {
            value: false
        }
    },
    mounted() {
        this.value = (this.$route.query[this.filterValue] === "true");
    },
    watch: {
        value(newVal, oldVal) {
            let query = Object.assign({}, this.$route.query);
            query[this.filterValue] = (newVal) ? "true" : "false";
            this.$router.replace({query}, (to, from, next) => {
                trackEvent({
                    event: 'Filter - ' + this.checkboxName,
                    target: to.fullPath,
                    value: this.value,
                    destination: (this.$store) ? this.$store.state.destination : null,
                    'interaction-type': 'noninteraction',
                })
            });
        },
        '$route.query'() {
            if(typeof this.$route.query[this.filterValue] != 'undefined') {
                this.value = (this.$route.query[this.filterValue] === "true");
            } else {
                this.value = false;
            }
        }
    },
    components: {
        Checkbox
    }
}
</script>

